import { differenceInYears } from "date-fns";

export const getUsefulLifeBaseDate = (manufacturingDate, importDate) =>
  manufacturingDate || importDate || null;

const parseUsefulLifeDate = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "string") {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
    if (match) {
      const [, year, month, day] = match;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const getRestUsefulLife = (baseDate, usefulLifeYears) => {
  if (!baseDate || !usefulLifeYears) return null;

  const normalizedUsefulLifeYears = Number(usefulLifeYears);
  const baseDateObj = parseUsefulLifeDate(baseDate);
  const currentDate = new Date();

  if (!baseDateObj || Number.isNaN(normalizedUsefulLifeYears)) {
    return null;
  }

  const yearsElapsed = Math.max(differenceInYears(currentDate, baseDateObj), 0);
  const remainingUsefulLife = Math.max(normalizedUsefulLifeYears - yearsElapsed, 0);

  if (remainingUsefulLife <= 0) {
    return {
      remainingUsefulLife: 0,
      yearsElapsed,
      remainingUsefulLifeMessage: "Vida útil agotada"
    };
  }

  if (remainingUsefulLife < 1) {
    return {
      remainingUsefulLife,
      yearsElapsed,
      remainingUsefulLifeMessage: "Menos de un año"
    };
  }

  return {
    remainingUsefulLife,
    yearsElapsed,
    remainingUsefulLifeMessage: `Restan ${remainingUsefulLife} ${
      remainingUsefulLife === 1 ? "año" : "años"
    }`
  };
};

export const getUsefulLifeStatus = (remainingUsefulLife) => {
  if (remainingUsefulLife == null) {
    return {
      key: "unknown",
      label: "No disponible",
      bgColor: "transparent",
      textColor: "#737373"
    };
  }

  if (remainingUsefulLife <= 1) {
    return {
      key: "red",
      label: "Crítica (≤ 1 año)",
      bgColor: "#fce4e4",
      textColor: "#F43F5E"
    };
  }

  if (remainingUsefulLife <= 3) {
    return {
      key: "yellow",
      label: "Media (2-3 años)",
      bgColor: "#fff4cc",
      textColor: "#CCAF00"
    };
  }

  return {
    key: "green",
    label: "Buena (≥ 4 años)",
    bgColor: "#d8f5d1",
    textColor: "#33A985"
  };
};

export const getTooltipContent = (baseDate, usefulLifeYears) => {
  const data = getRestUsefulLife(baseDate, usefulLifeYears);

  if (!data) {
    return (
      <div>
        <p className="create-label">Información no disponible</p>
      </div>
    );
  }

  const { yearsElapsed, remainingUsefulLife, remainingUsefulLifeMessage } =
    data;
  const status = getUsefulLifeStatus(remainingUsefulLife);

  return (
    <div>
      <div className="HContainer">
        <p className="toolkit-title">Vida Útil:</p>
        <p className="create-label">
          {usefulLifeYears || "No disponible"} años
        </p>
      </div>
      <div className="HContainer">
        <p className="toolkit-title">Años en uso:</p>
        <p className="create-label">{yearsElapsed ?? "No disponible"}</p>
      </div>
      <div
        style={{
          backgroundColor: status.bgColor,
          padding: "5px 10px",
          borderRadius: "6px",
          marginTop: "5px"
        }}
      >
        <p className="create-label" style={{ margin: 0 }}>
          {remainingUsefulLifeMessage}
        </p>
      </div>
    </div>
  );
};
